import { render } from "./SectionDataTable.vue?vue&type=template&id=dccd009c&scoped=true"
import script from "./SectionDataTable.vue?vue&type=script&lang=js"
export * from "./SectionDataTable.vue?vue&type=script&lang=js"

import "./SectionDataTable.vue?vue&type=style&index=0&id=dccd009c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dccd009c"]])

export default __exports__